import { useSelector } from "react-redux";
import {
	selectFullTimeAt,
	selectHalfTimeAt,
	selectSecondHalfStartTime,
	selectStartTime,
	selectTimeCorrection,
} from "../redux/broadcast/broadcast.selectors";

export function useMatchMinute(postDate: string, storedMinute?: string | null): string | null {
	const startTime = useSelector(selectStartTime);
	const halfTimeAt = useSelector(selectHalfTimeAt);
	const secondHalfStartTime = useSelector(selectSecondHalfStartTime);
	const fullTimeAt = useSelector(selectFullTimeAt);
	const timeCorrection = useSelector(selectTimeCorrection);

	// Posts snapshot their minute at creation time (server/lib/match-minute.ts)
	// so a later time correction can't reach back and reshape it — only
	// posts made before that existed fall through to the dynamic calculation.
	if (storedMinute) return storedMinute;

	if (!startTime) return "Build up";

	const postMs = new Date(postDate).getTime();

	if (timeCorrection) {
		const correctionMs = new Date(timeCorrection.appliedAt).getTime();
		if (postMs >= correctionMs) {
			const mins =
				timeCorrection.minute + Math.ceil((postMs - correctionMs) / 60000);
			if (mins > 90) return `90+${mins - 90}'`;
			if (mins > 45 && timeCorrection.minute >= 46) return `${mins}'`;
			if (mins > 45) return `45+${mins - 45}'`;
			if (mins < 0) return "Build up";
			return `${Math.max(mins, 1)}'`;
		}
	}

	if (secondHalfStartTime) {
		const secondHalfMs = new Date(secondHalfStartTime).getTime();
		if (postMs >= secondHalfMs) {
			const mins = Math.max(
				46,
				Math.ceil((postMs - secondHalfMs) / 60000) + 45,
			);
			if (mins > 90) return `90+${mins - 90}'`;
			return `${mins}'`;
		}
	}

	if (fullTimeAt && postMs >= new Date(fullTimeAt).getTime()) return "FT";
	if (halfTimeAt && postMs >= new Date(halfTimeAt).getTime()) return "HT";

	const mins = Math.ceil((postMs - new Date(startTime).getTime()) / 60000);
	if (mins < 0) return "Build up";
	if (mins > 45) return `45+${mins - 45}'`;
	return `${Math.max(mins, 1)}'`;
}
